import { useDispatch } from 'react-redux';
import { MODAL_FORM, FORM_ACTIONS } from 'constants/form';
import { openModal } from 'actions/modal';
import MODAL from 'constants/modal';

const useLogic = () => {
  const dispatch = useDispatch();
  const handleBookPAC = teacherIdFromAcFlow => {
    dispatch(
      openModal(
        MODAL_FORM.ASSIGN_TEACHER_CONTAINER,
        {
          size: 'custom',
          width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
          height: MODAL.UPDATE_HEIGHT,
        },
        {
          formType: FORM_ACTIONS.CREATE,
          data: {
            teacherIdFromAcFlow,
          },
        },
      ),
    );
  };

  return {
    handleBookPAC,
  };
};

export default useLogic;
